'use client'

import { focusMainContent } from '@/components/layout/focusMainContent'

const SkipToMainLink = () => {
  return (
    <a
      href="#main-content"
      onClick={focusMainContent}
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-primary-ink-100 focus:px-4 focus:py-2 focus:text-white focus:outline-none focus:ring-2 focus:ring-primary-green-150 focus:ring-offset-2">
      Skip to main content
    </a>
  )
}

export default SkipToMainLink
